import { Logger, ILogObj } from 'tslog';

/**
 * Logging levels:
 * 0: silly
 * 1: trace
 * 2: debug
 * 3: info
 * 4: warn
 * 5: error
 * 6: fatal
 */

const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL || sessionStorage.getItem('logLevel') || 'info';

const logger: Logger<ILogObj> = new Logger({
  name: 'PCO products and services',
  minLevel: getLogLevel(LOG_LEVEL),
  type: 'pretty',
  prettyLogTemplate: '{{logLevelName}}\t[{{name}}]\t',
});

function getLogLevel(level: string): number {
  const levels: Record<string, number> = {
    silly: 0,
    trace: 1,
    debug: 2,
    info: 3,
    warn: 4,
    error: 5,
    fatal: 6,
  };
  return levels[level.toLowerCase()] ?? 3; // default to info
}

export { logger };
